<template>
  <div ref="dialogContainer" role="dialog" :aria-label="dialogLabel" aria-modal="true" tabindex="-1" class="dialog-focus-hidden">
    <Rewards id="nav-rewards" />
    <AccountLinks id="nav-account-links" />
    <div id="nav-account-drawer-slot">
      <LazyLoadWhenInViewport v-if="cardActivationEnhancementsAccountFlyoutEnabled && cardActivationEnhancementsEnabled">
        <div class="account-flyout-banner">
          <ClientOnly>
            <CreditcardBannerConsumableCreditCardBanner
              source="accountflyout"
              :card-activation-enhancements-enabled="cardActivationEnhancementsEnabled"
              bringback-page="CreditGateway"
              credit-acquisition="accountflyout"
            />
          </ClientOnly>
        </div>
      </LazyLoadWhenInViewport>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineAsyncComponent, onMounted, nextTick } from 'vue';
import Rewards from './Rewards';
import AccountLinks from './AccountLinks.common';
import CreditCardBannerSkeleton from '../footer/CreditCardBannerSkeleton.vue';
import LazyLoadWhenInViewport from '~/components/utils/LazyLoadWhenInViewport.vue';
import useKillswitches from '~/composables/useKillswitches';

const CreditcardBannerConsumableCreditCardBanner = defineAsyncComponent({
  loader: () => import('@nuxt-common/creditcard-banner-consumable/app/components/CreditCardBanner.vue'),
  loadingComponent: CreditCardBannerSkeleton,
});

const envProps = useEnvProps();
const isMcom = envProps.isMcom;
const dialogLabel = isMcom ? 'star rewards' : 'loyalist';
const dialogContainer = ref(null);
const killswitches = useKillswitches();
const cardActivationEnhancementsEnabled = computed(() => killswitches?.value?.cardActivationEnhancementsEnabled);
const cardActivationEnhancementsAccountFlyoutEnabled = computed(() => killswitches?.value?.cardActivationEnhancementsAccountFlyoutEnabled);

onMounted(() => {
  nextTick(() => {
    dialogContainer.value?.focus();
    window.dispatchEvent(new CustomEvent('navAccountDrawerOpen'));
  });
});
</script>

<style lang="scss">
@import '~/assets/scss/mixins';

#nav-rewards + #nav-account-links {
  border-top: 1px solid $gray-3-color;
}

.dialog-focus-hidden:focus {
  outline: none;
}

#nav-account-drawer-slot {
  margin-top: 24px;
  padding-top: 24px;
}
</style>
